import imageCompression, {Options} from 'browser-image-compression';

interface ImageDimensions {
  width: number;
  height: number;
}

export interface CompressionResult {
  blob: Blob;
  scaleFactor: number;
}

/**
 * Gets image dimensions by createImageBitmap.
 */
const getImageDimensions = async (blob: Blob): Promise<ImageDimensions> => {
  const imageBitmap = await createImageBitmap(blob);
  const dimensions = {width: imageBitmap.width, height: imageBitmap.height};
  imageBitmap.close();
  return dimensions;
};

/**
 * Compresses an image to a maximum width and a quality.
 * @param file
 * @returns
 */
export const getCompressedImage = async (file: Blob): Promise<CompressionResult> => {
  const options: Options = {
    initialQuality: 0.75,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
    alwaysKeepResolution: true,
    fileType: 'image/webp',
  };

  try {
    const originalDimensions = await getImageDimensions(file);

    const result = await imageCompression(
      file instanceof File ? file : new File([file], 'image.webp', {type: file.type}),
      options,
    );

    const compressedDimensions = await getImageDimensions(result);
    const scaleFactor = compressedDimensions.width / originalDimensions.width;

    return {blob: result, scaleFactor};
  } catch (error) {
    console.error('Image compression failed:', error);
    throw new Error('Failed to compress image');
  }
};
